import { render, staticRenderFns } from "./FaqBlock.vue?vue&type=template&id=59759d5c&scoped=true&"
import script from "./FaqBlock.vue?vue&type=script&lang=ts&"
export * from "./FaqBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FaqBlock.vue?vue&type=style&index=0&id=59759d5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59759d5c",
  null
  
)

export default component.exports